import Ajax from '@/lib/ajax'

export default {
  editChannel(channelObj: any) {
    return Ajax.post(
      '/api/services/app/Channel/CreateOrUpdateChannel',
      channelObj
    )
  },
  getChannelList(parentid: number) {
    return Ajax.get('/api/services/app/Channel/GetChannelList?ParentId='+parentid )
  },
  getChannelDetail(id: string | number) {
    return Ajax.get('/api/services/app/Channel/GetChannelForEdit?Id=' + id)
  },
  deleteChannel(idArr: any[]) {
    const text = idArr.join('&Id=')
    return Ajax.delete('/api/services/app/Channel/DeleteChannel?Id=' + text)
  }
}
